<div>
  <ion-header>
  <ion-toolbar color="light">
    <ion-title>Select a Brand</ion-title>
  </ion-toolbar>
</ion-header>
<div>
  <ion-searchbar></ion-searchbar>
  <ion-list *ngFor="let marke of makes">
    <ion-item>{{marke.name}}</ion-item>
  </ion-list>
</div>
</div>
